import React from "react";
import "assets/styles/container/style.css";
import MainContent from "components/employees";
import { AlluserProvider } from "context/AlluserContext";

const Container = (props) => {
  let userData = window.$user_profile;
  if (!userData?.user_sess?.userCanAccessEmployees) {
    return (
      <div style={{ padding: "50px 0", textAlign: "center" }}>
        <h3>
          You do not have permission to access this profile page. Only profile
          owners, HR admins, and system administrators can view it.
        </h3>
        <h5 style={{ marginTop: "10px" }}>
          If you believe you should have access, please contact the
          administrators
        </h5>
        <a
          href="https://sites.google.com/exotravel.me/exo-24"
          style={{ fontSize: "18px" }}
        >
          Go to EXO24
        </a>
      </div>
    );
  }
  return (
    <AlluserProvider>
      <div id="alluser-content" className="inner-container">
        <MainContent />
      </div>
    </AlluserProvider>
  );
};
export default Container;
